import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType, FileType } from "@/common/types/common";
import type { LaboratoryPayloadType } from "@/common/types/laboratory";

export async function laboratoryList(account_id: string, query?: QueryType) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/laboratory/list${queryString}`,
  );
}

export async function laboratoryCreate(
  account_id: string,
  payload: LaboratoryPayloadType,
) {
  return await clientAxios.post(
    `account/${account_id}/laboratory/create`,
    payload,
  );
}

export async function laboratoryGet(account_id: string, laboratory_id: string) {
  return await clientAxios.get(
    `account/${account_id}/laboratory/${laboratory_id}/show`,
  );
}

export async function laboratoryUpdate(
  account_id: string,
  laboratory_id: string,
  payload: LaboratoryPayloadType,
) {
  return await clientAxios.put(
    `account/${account_id}/laboratory/${laboratory_id}/update`,
    payload,
  );
}

export async function laboratoryDelete(
  account_id: string,
  laboratory_id: string,
) {
  return await clientAxios.del(
    `account/${account_id}/laboratory/${laboratory_id}/delete`,
  );
}

export async function laboratoryModelCSV(account_id: string) {
  return await clientAxios.get(`account/${account_id}/laboratory/csv/model`);
}

export async function laboratoryUpload(account_id: string, payload: FileType) {
  return await clientAxios.post(
    `account/${account_id}/laboratory/upload`,
    payload,
  );
}
